exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control--3H075 {\n  max-width: 260px;\n}\n\n.modal--3kmo6 {\n  max-width: 600px;\n}\n\n.modal-content--34kY4 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.inputs--1fchC {\n  max-width: 380px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.summary--1M4dp {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--1okQj {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.submit--1okQj .button--2OpvK {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"control": "control--3H075",
	"modal": "modal--3kmo6",
	"modal-content": "modal-content--34kY4",
	"inputs": "inputs--1fchC",
	"summary": "summary--1M4dp",
	"submit": "submit--1okQj",
	"button": "button--2OpvK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-admin/Users/CreateUser/CreateUser.m.scss
// module id = 1586
// module chunks = 0